"use client";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const GGSSideMenu = ({ menu, currentPage, isFrench, draftPreview }) => {
  let currentMenu;
  if (draftPreview) {
    currentMenu = menu.find((item) =>
      item?.attributes?.slug?.includes("ggs/" + currentPage.split("/")[1])
    )?.attributes;
    currentMenu = {
      title: "Draft/Preview",
      slug: "draft-preview",
      url: "#",
      children: {
        data: [
          {
            attributes: {
              title: "draft/preview children",
              slug: "draft-preview-children",
              url: "#",
              children: { data: [] },
            },
          },
        ],
      },
    };
  } else {
    currentMenu = menu.find(
      (item) => item.attributes.slug === "ggs/" + currentPage.split("/")[0]
    )?.attributes;
  }

  return (
    <>
      <div className="ggs-section-navigation show-for-large">
        <ul className="ggs-aside-navigation-list no-bullet" aria-hidden="false">
          <li className="ggs-aside-navigation-list-item ggs-aside-navigation-level-2">
            <span
              className="ggs-aside-navigation-list-expand"
              data-toggle="ggs-aside-navigation-list"
              tabIndex="0"
              role="button"
              aria-controls="ggs-aside-navigation-list"
              data-is-focus="false"
              data-yeti-box="ggs-aside-navigation-list"
              aria-haspopup="true"
              aria-expanded="false"
              id="gt5f7x-dd-anchor"
            >
              <span className="far fa-chevron-down" aria-hidden="true"></span>
              <span className="show-for-sr">{currentMenu.title} Menu</span>
            </span>
            <a
              href={
                currentMenu.url ||
                `/${currentMenu.slug}${isFrench ? "?lang=fr-CA" : ""}`
              }
              className="ggs-aside-navigation-list-item-link"
            >
              {currentMenu.title}
            </a>
            <ul
              className="ggs-aside-navigation-list no-bullet has-position-bottom has-alignment-left"
              id="ggs-aside-navigation-list"
              data-dropdown=""
              aria-labelledby="gt5f7x-dd-anchor"
              aria-hidden="false"
              data-yeti-box="ggs-aside-navigation-list"
              data-resize="ggs-aside-navigation-list"
              data-i="uql36k-i"
              data-events="resize"
            >
              <FontAwesomeIcon
                icon={faChevronRight}
                className="fontawesome-nav-icon"
                fixedWidth
              />
              {currentMenu.children.data.map((item, index) => {
                if (item.attributes.hidden === true) {
                  return null;
                } else
                  return (
                    <li
                      key={`submenu${index}`}
                      className={`ggs-aside-navigation-list-item ggs-aside-navigation-level-3 ${
                        `/ggs/${currentPage}` ===
                          `/${currentMenu?.slug}/${item?.attributes?.slug}` &&
                        "active"
                      }`}
                    >
                      <a
                        href={
                          item.attributes.url ||
                          `/${currentMenu.slug}/${item.attributes.slug}${
                            isFrench ? "?lang=fr-CA" : ""
                          }`
                        }
                        className="ggs-aside-navigation-list-item-link"
                      >
                        {item.attributes.title}
                      </a>
                    </li>
                  );
              })}
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default GGSSideMenu;
